import { SELECTED_STOCK } from "../actions/types";

export default function (state = [], action) {
  switch (action.type) {
    case SELECTED_STOCK:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/currentCarReducer.js